export type FrameworkNames = {
    title: string;
    shortIdentifier?: string | null;
};

/** Legacy frameworks were saved with no short identifier, so they fall back on their title. */
export const toFrameworkLabel = ({ title, shortIdentifier }: FrameworkNames): string => {
    const identifier = shortIdentifier?.trim();

    return identifier ? `${identifier} — ${title}` : title;
};
